type RealtimeVoiceOption = {
    id: string;
    label: string;
    recommended: boolean;
};

export const realtimeVoices = [
    {id: 'marin', label: 'Marin', recommended: true},
    {id: 'cedar', label: 'Cedar', recommended: true},
    {id: 'alloy', label: 'Alloy', recommended: false},
    {id: 'ash', label: 'Ash', recommended: false},
    {id: 'ballad', label: 'Ballad', recommended: false},
    {id: 'coral', label: 'Coral', recommended: false},
    {id: 'echo', label: 'Echo', recommended: false},
    {id: 'sage', label: 'Sage', recommended: false},
    {id: 'shimmer', label: 'Shimmer', recommended: false},
    {id: 'verse', label: 'Verse', recommended: false}
] as const satisfies readonly RealtimeVoiceOption[];

export type RealtimeVoice = (typeof realtimeVoices)[number]['id'];

export const defaultRealtimeVoice: RealtimeVoice = 'marin';

export const isRealtimeVoice = (value: unknown): value is RealtimeVoice =>
    typeof value === 'string' &&
    realtimeVoices.some(voice => voice.id === value);

export const normalizeRealtimeVoice = (value: unknown): RealtimeVoice =>
    isRealtimeVoice(value) ? value : defaultRealtimeVoice;

export const getRealtimeVoiceLabel = (voiceId: RealtimeVoice): string =>
    realtimeVoices.find(voice => voice.id === voiceId)?.label ?? voiceId;
